export enum DataHooks {
  LINK = 'explore-plans-link',
}
